export enum TipoConfiguracaoAnoBaseEnum {

  AnoBase = 1,
  EntregaRda = 2,
  Retificacao = 3,
  Auditoria = 4,
  EntregaRdaSuspensao = 5,
  AuditoriaSuspensao = 6,
  LimiteUtilizacaoCredito = 7,
  CartaCredito = 8,
  RdaPadis = 10,
  EntregaRdaPadisSuspensao = 11,
  AuditoriaPadis = 12,
  RetificacaoCartaCredito = 13

}
